export default __webpack_public_path__ + "static/avasta-d9a081013ad1508ed10ea10615300836.ttf";